"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var AddComment_1 = __importDefault(require("../AddCommentComponent/AddComment"));
var CommentDeleteOverlay_1 = __importDefault(require("../CommentDeleteOverlay/CommentDeleteOverlay"));
var commentTransitionDuration = 200;
var commentTransitionDelay = 50;
var CommentThread = (function (_super) {
    __extends(CommentThread, _super);
    function CommentThread() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderComments = function () {
            var children = _this.props.children;
            var comments = children;
            return react_1.default.Children.map(comments, function (comment, idx) { return (react_1.default.createElement("div", { className: "comment-thread__comment-container", style: { animationDelay: "".concat(idx * commentTransitionDelay, "ms") } },
                comment,
                react_1.default.createElement("div", { className: "comment-thread__comment-border" }))); });
        };
        _this.renderDeleteThread = function () {
            var _a = _this.props, onConfirmDelete = _a.onConfirmDelete, onCancelDelete = _a.onCancelDelete;
            return (react_1.default.createElement(CommentDeleteOverlay_1.default, { onCancelDelete: onCancelDelete, onConfirmDelete: onConfirmDelete, message: "Delete comment thread?", withBorderRadius: true }));
        };
        return _this;
    }
    CommentThread.prototype.render = function () {
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName, onCancelReply = _a.onCancelReply, onSendReply = _a.onSendReply, currentlyDeleting = _a.currentlyDeleting, children = _a.children, usersInAccount = _a.usersInAccount, commentPlaceholder = _a.commentPlaceholder, mentionsEnabled = _a.mentionsEnabled, permissionsStore = _a.permissionsStore, projectId = _a.projectId, hasEditAccess = _a.hasEditAccess, onInviteUser = _a.onInviteUser;
        var commentCount = react_1.default.Children.count(this.props.children);
        return (react_1.default.createElement(kaleidoscope_1.Panel, { key: "comment-thread", className: "comment-thread" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionAppear: true, transitionAppearTimeout: (commentCount - 1) * commentTransitionDelay + commentTransitionDuration, transitionEnter: false, transitionLeave: false, transitionName: "comment-thread__comment-transition" }, this.renderComments())),
            hasEditAccess && (react_1.default.createElement("div", { className: "comment-thread__add-comment-container" },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionAppear: true, transitionAppearTimeout: commentCount * commentTransitionDelay + commentTransitionDuration, transitionEnter: false, transitionLeave: false, transitionName: "comment-thread__comment-transition" },
                    react_1.default.createElement("div", { key: "comment-thread__add-comment", style: { animationDelay: "".concat((commentCount + 1) * commentTransitionDelay, "ms") } },
                        react_1.default.createElement(AddComment_1.default, { firstName: firstName, lastName: lastName, onCancel: onCancelReply || lodash_1.noop, onSend: onSendReply, autoFocus: react_1.default.Children.count(children) === 0, usersInAccount: usersInAccount, placeholderMessage: commentPlaceholder, mentionsEnabled: mentionsEnabled, permissionsStore: permissionsStore, projectId: projectId, onInviteUser: onInviteUser }))))),
            currentlyDeleting && this.renderDeleteThread()));
    };
    CommentThread = __decorate([
        mobx_react_1.observer
    ], CommentThread);
    return CommentThread;
}(react_1.default.Component));
exports.default = CommentThread;
